import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        },
        noWrap: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        containerStatus: {
            borderRadius: 16,
            padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
            background: theme.palette.common.beige,
            color: theme.palette.common.orange,
            lineHeight: 'normal',
        },
    }
})

export default useStyles
